<div class="section-header">
    <h2>Nuestra Galería</h2>
    <div class="divider"></div>
</div>

    <div *ngIf="images"  class="image-gallery" >
        <div *ngFor="let image of images; let index = index"  key="index">
            <img 
                [src]="image.thumbnailImageSrc" 
                [alt]="image.alt" 
                style="cursor: pointer" 
               
                (click)="imageClick(index)" />
        </div>
    </div>
    <p-galleria
        [value]="images"
        [(visible)]="displayCustom"
        [(activeIndex)]="activeIndex"
        [responsiveOptions]="responsiveOptions"
        [containerStyle]="{ 'max-width': '850px' }"
        [numVisible]="7"
        [circular]="true"
        [fullScreen]="true"
        [showItemNavigators]="true"
        [showThumbnails]="false">
        <ng-template pTemplate="item" let-item>
            <img 
                [src]="item.previewImageSrc" 
                style="width: 100%; max-height: 600px; display: block;" />
        </ng-template>
    </p-galleria>


        